import { put, call, takeEvery } from "redux-saga/effects";
import { getInstitutionFromRoutingNumber } from "../utils/requests";

export function* getAchInstitutionFromEndpoint({ routingNumber }) {
  try {
    const data = yield call(getInstitutionFromRoutingNumber, routingNumber);
    if(data != null && data.Name != null){
      yield put({
        type: "SET_INSTITUTION",
        payload: data
      });
    } else {
      yield put ({
        type: "INVALID_ACH_INSTITUTION"
      })
    }
  } catch (error) {
    // This is very important, fail loudly
    yield put ({
      type: "INVALID_ACH_INSTITUTION"
    })
  }
}

// Watch for token request and execute action to set token
export function* watchAchInstitutionRequest() {
  yield takeEvery("SEARCH_FOR_INSTITUTION", getAchInstitutionFromEndpoint);
}


// WEBPACK FOOTER //
// ./src/sagas/achInstitution.sagas.js